export const openUrl = (url) => {
  window.open(url, '_blank')
}
